module.exports = __webpack_public_path__ + "img/5-3.7dfd9893.png";